import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-shrink-0" }
const _hoisted_2 = { class: "d-flex ms-3" }
const _hoisted_3 = { class: "btn btn-flex flex-center btn-bg-white btn-text-gray-500 btn-active-color-primary rounded-circle px-4 m-0 h-40px" }
const _hoisted_4 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left p-0" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "d-flex ms-3" }
const _hoisted_8 = { class: "dropdown" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-flex flex-center btn-bg-white btn-text-gray-500 rounded-circle px-4 m-0 h-40px",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell p-0" })
  ])
], -1)
const _hoisted_10 = {
  class: "dropdown-menu p-2",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_11 = {
  key: 0,
  class: "my-2"
}
const _hoisted_12 = { class: "border-bottom" }
const _hoisted_13 = { class: "border-start border-2 border-danger p-2 text-dark" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "Tiene reportes pendientes en la bitácora.", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  tooltip: "New Member",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_invite_friends"
}, null, -1)
const _hoisted_16 = { class: "d-flex ms-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 m-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person p-0" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn p-0 m-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }, _hoisted_6)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("ul", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bitacoras, (bitacora, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              style: {"width":"233px","max-height":"400px","overflow-y":"auto"}
            }, [
              _createVNode(_component_router_link, { to: { name: 'profile-campaigns' } }, {
                default: _withCtx(() => [
                  (bitacora.justification == null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(bitacora.message), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128)),
          _hoisted_14
        ])
      ]),
      _hoisted_15
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_router_link, {
        class: "btn btn-flex flex-center btn-bg-white btn-text-gray-500 btn-active-color-blue rounded-circle px-4 m-0 h-40px",
        to: { name: 'profile-overview' }
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      })
    ])
  ]))
}